import React from 'react';
import { Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import UsersPageRoute from './UsersPageRoute';
import ShelfPageRoute from './ShelfPageRoute';

const basePath = '/v2/users/:userId';

export default (
  <Route
    path={basePath}
    element={
      <MainLayout deprecated>
        <Outlet />
      </MainLayout>
    }
  >
    {/* UsersPageRoute wraps the page HERE rather than sitting on the layout route above, and that
        placement is load-bearing -- do not "tidy" it back into a parent/child pair (CORE-79114).
        ShelfPageRoute's data depends on the user UsersPageRoute fetches. Both mechanisms that load
        route data walk a single route's element chain and run what they find in order
        (fetchDataForCurrentRoutes via when/sequence today, bindLoaders via promise chaining once
        the route is converted). Split across two routes they become two loaders, which react-router
        runs in PARALLEL -- the shelf would look for a user that has not arrived yet, fetch nothing,
        and render an empty shelf with a 200. app/routes/print/index.js nests the print equivalent
        the same way, for the same reason. */}
    <Route
      path={`${basePath}/shelves/:shelfName/*`}
      element={
        <UsersPageRoute>
          <ShelfPageRoute />
        </UsersPageRoute>
      }
    />
    {/* v6 ranks a splat below an index route, so without this the parent's OWN path matches
        the layout alone and <Outlet /> renders nothing -- an empty 200, not the 404. */}
    <Route index element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
